import React from 'react';

import { GuideCard } from '@dom/components';
import CardsSlider from '../CardsSlider';

import guides from './data.json';

export default function FeaturedGuides({ title, city }) {
  const href = `/list?baseCity=${city}`;
  return (
    <CardsSlider
      Card={GuideCard}
      title={title}
      seeAllLink={href}
      data={guides[city]}
      endpoint={`guides_in_${city}`}
      showNoOfCards={3}
    />
  );
}
